import Rails from 'rails-ujs';
// Setup react-rails.
// The ERB helper react_component will access to components found in directories
// under app/javascript/apps and matching the regex below.
var componentRequireContext = require.context(
  'apps',
  true,
  // Directories that contain components mounted with react-rails.
  // We do a negative lookahead to eliminate *.test.js and *.stories.js since we
  // never want to mount those anyway. This fixes an error with calling
  // react_component to mount a component that had a stories file in the same dir
  /(?!.*\.(test|stories))(cart\/wrapped|forms|calculator\/wrapped|calculator\/components|sms_subscriptions\/wrapped|direct_mail\/wrapped|product\/components|notification\/components)/
);
var ReactRailsUJS = require('react_ujs'); // eslint-disable-line import/no-commonjs
ReactRailsUJS.useContext(componentRequireContext);

// Setup rails-ujs
Rails.start();
